import {ControlledListHeadingItem} from '@Components/controlled-list/components/controlled-list-heading-item';
import {useAppSelector} from '../../../../hooks';
import type {LIST_ITEM_TYPE, ListDefaultItemBaseStorage} from '../../list.types';

interface ListHeadingItemProps {
  id: string;
  listId: string;
}

export interface ListHeadingItemStorage extends ListDefaultItemBaseStorage {
  type: LIST_ITEM_TYPE.HEADING;
}

export function ListHeadingItem({...props}: ListHeadingItemProps) {
  const listHeadingData = useAppSelector((state) => {
    return state.list.listItemData.listItemsHashMap[props.id] as ListHeadingItemStorage;
  });

  return listHeadingData ? <ControlledListHeadingItem id={listHeadingData.id} text={listHeadingData.text} className={listHeadingData.className} /> : null;
}
